module.exports = __webpack_public_path__ + "img/banner.448ccda7.jpg";